import { Redirect, useParams } from 'react-router-dom'
import PageLoader from '@/authenticated/components/layout/PageLoader'

/**
 * Grid Support no longer has its own settings page. The on/off toggle now lives
 * inline on the "Be a Watt Hero" card (thermostat Programs tab), and the
 * event-temperature steppers moved to the Event Temperatures page. This redirect
 * keeps existing links working (older mobile builds, push notifications, deep
 * links) by forwarding to the Event Temperatures page.
 */
type PathParams = { deviceId: string | undefined }

export default function ThermostatGridSupportPageRoot() {
  const { deviceId } = useParams<PathParams>()
  if (!deviceId) return <PageLoader />
  return <Redirect to={`/devices/thermostat/${deviceId}/event-temperatures`} />
}
